// extracted by mini-css-extract-plugin
export default {"containerMain":"AreaCliente_containerMain__zdsxP"};